<template>
	<div>
		<v-dialog v-model="dialog_crop_image" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
	        <v-card style="background-color: grey;">
				<v-toolbar flat>
				    <v-toolbar-side-icon @click="closeDialogWeb"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">Edit Logo</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <v-btn round-borders outline @click="fn_cropImage">Done</v-btn>
				</v-toolbar>
				
		        <v-card-text full-height>
					<!-- <vue-croppie ref="croppieRef" :enableOrientation="true" :boundary="{ width: 260, height: 250}" :viewport="{ width:200, height:200, 'type':'square' }" :enableResize="false">
					</vue-croppie> -->

					 <cropper
					 	ref="cropper"
						:src="srcImage"
						:auto-zoom="false"
						@change="change"
						class="cropper"
						image-class="cropper__image"
						:stencil-props="{
							aspectRatio:aspectRatio
						}"
						@ready="onReady"

					/>


					<!-- <v-btn flat icon @click="fn_rotate(-90)"><v-icon>rotate_left</v-icon></v-btn> -->
					<!-- <div center-align>
						<v-btn flat outline @click="fn_rotate(90)">Rotate <v-icon right>rotate_right</v-icon></v-btn>
					</div> -->
		        </v-card-text>
				<v-card-actions style="border-top: 1px #ddd solid;display: block;padding: 0;">
					<v-layout row wrap pt-3 pb-3 font-medium style="letter-spacing: 1px;background-color: #fff;">
						<v-flex xs3 sm3 md3 right-border center-align redcolor @click="onAspectRatioChange(1/1)">1:1</v-flex>
						<v-flex xs3 sm3 md3 right-border center-align redcolor @click="onAspectRatioChange(3/4)">3:4</v-flex>
						<v-flex xs3 sm3 md3 right-border center-align redcolor @click="onAspectRatioChange(3/2)">3:2</v-flex>
						<v-flex xs3 sm3 md3 right-border center-align redcolor @click="onAspectRatioChange(16/9)">16:9</v-flex>
					</v-layout>
					<v-layout row wrap style="background: #333;">
						<v-flex xs6 sm6 md6 right-border pa-2 pt-3 font-medium style="color: #fff;letter-spacing:1px;" center-align @click="onAspectRatioChange(null)">RESET</v-flex>
						<v-flex xs6 sm6 md6 pa-2 pt-3 center-align @click="$refs.cropper.rotate(90)"><v-icon style="color: #fff !important;">rotate_right</v-icon></v-flex>
					</v-layout>
				</v-card-actions>
		        <!-- <v-card-actions>
		        	<v-spacer></v-spacer>
		        	<v-btn small color="blue darken-1" flat @click="dialog_crop_image=false">cancel</v-btn>
          			<v-btn small color="blue darken-1" flat @click="fn_cropImage">done</v-btn>
		        </v-card-actions> -->
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
	export default{
		data(){
			return{
				dialog_crop_image:false,
				cropped:null,
				croppedImage:null,
				aspectRatio:null,
				srcImage:null
			}
		},
		components:{
			Cropper
		},	
		methods:{
			openDialogWeb: function (image) {
				this.srcImage = 'data:image/jpeg;base64,' + image;
				this.dialog_crop_image = true;
			},
			closeDialogWeb: function () {
				this.dialog_crop_image = false;
			},

			change({coordinates, canvas}) {
				console.log(coordinates, canvas);
				this.croppedImage = canvas.toDataURL();
			},
			fn_rotate(rotationAngle) {
	            // Rotates the image
	            this.$refs.croppieRef.rotate(rotationAngle);
	        },

			// onReady() {

			// this.$refs.cropper.setCoordinates(({ coordinates, imageSize }) => ({
			// 	left: 0,
			// 	top: 0,
			// 	width: imageSize.width,
			// 	height : imageSize.height
			// }))
			// },
			fn_cropImage: function(){
				this.$parent.fn_uploadLogo(this.croppedImage);
			},

			onReady() {
				let cropper = this.$refs.cropper;
				let imageSize = cropper.imageSize;
				cropper.setCoordinates({
					left: 0,
					top: 0,
					width: imageSize.width,
					height: imageSize.height,
				});
				// this.resetStencil(imageSize);
			},

			  onAspectRatioChange(ratio) {
				this.aspectRatio = ratio;

				if(!ratio){
					this.$refs.cropper.reset();
					setTimeout(() => {
						this.onReady();
					}, 500);
					// this.$refs.cropper.rotate(0);
				}
				else{
					// Wait for next DOM update cycle
					this.$nextTick(() => {
						const cropper = this.$refs.cropper;
						const imageSize = cropper.imageSize;
						this.resetStencil(imageSize);
					});
				}
				
			},

			resetStencil({ width, height }) {
				const cropper = this.$refs.cropper;

				// Maintain full width or height while respecting aspect ratio
				const aspect = this.aspectRatio;
				let stencilWidth = width;
				let stencilHeight = width / aspect;

				if (stencilHeight > height) {
					stencilHeight = height;
					stencilWidth = height * aspect;
				}

				cropper.setCoordinates({
					left: (width - stencilWidth) / 2,
					top: (height - stencilHeight) / 2,
					width: stencilWidth,
					height: stencilHeight,
				});
				},
		 	// https://github.com/jofftiquez/vue-croppie
		//     fn_cropImage() {
		//       // Options can be updated.
		//       // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
		//       let options = {
		//         type: 'base64',
		//         size: { width: 200, height: 200 },
		//         format: 'jpeg'
		//       };
		//       this.$refs.croppieRef.result(options, output => {
		//           console.log(output);
		//           this.$parent.fn_uploadLogo(output);
		//         });
		//      },
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/business_logo/dialog_crop_image.vue